import React, { Component } from 'react';
import './Contact.css';

import n from './img2/phone.png';
import tt from './img/waze.png';
import tttt from './img2/whatsapp.png';

import Container from 'react-bootstrap/Container';
import emailjs from "emailjs-com";
import LightSpeed from 'react-reveal/LightSpeed';
import ReCAPTCHA from "react-google-recaptcha";

export default class Contact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      captcha: null,
      loading: false,
    };

    this.recaptchaRef = React.createRef();
  }

  handleCaptchaChange = (value) => {
    this.setState({ captcha: value });
  };

sendEmail = (e) => {
  e.preventDefault();

  if (!this.state.captcha) {
    alert("נא לאשר שאתה לא רובוט 🤖");
    return;
  }

  this.setState({ loading: true });

  emailjs
    .sendForm(
      "service_vegf8ui",
      "template_br2e9eh",
      e.target,
      "user_7XjWzaNdKiGR2BG0wBiLt"
    )
    .then((result) => {
      console.log("SUCCESS RESULT:", result);

      alert("הודעה נשלחה בהצלחה, ניצור קשר בקרוב!");

      e.target.reset();
      this.setState({ captcha: null, loading: false });

      if (this.recaptchaRef.current) {
        this.recaptchaRef.current.reset();
      }
    })
    .catch((error) => {
      console.log("EMAILJS ERROR:", error);

      alert("הודעה לא נשלחה - נסה שנית");

      this.setState({ loading: false });
    });
};
  render() {
    return (
      <div style={{ zIndex: 1 }}>
        <Container>
          <div style={styles.container}>

            {/* SOCIAL ICONS */}
            <div style={styles.socialWrapper}>
              <div style={styles.socialIcon}>
                <a href="tel:052-4816141">
                  <img src={n} alt="phone" style={styles.imgIcon} />
                </a>
              </div>

              <div style={styles.socialIcon}>
                <a href="https://wa.me/972524816141" target="_blank" rel="noreferrer">
                  <img src={tttt} alt="whatsapp" style={styles.imgIcon} />
                </a>
              </div>

              <div style={styles.socialIcon}>
                <a href="mailto:example@gmail.com">
                  <img src={tttt} alt="email" style={styles.imgIcon} />
                </a>
              </div>

              <div style={styles.socialIcon}>
                <a href="https://waze.com/ul?q=שוהם 5 רמת גן&navigate=yes" target="_blank" rel="noreferrer">
                  <img src={tt} alt="waze" style={styles.imgIcon} />
                </a>
              </div>
            </div>

            {/* FORM */}
            <LightSpeed right>
              <div style={styles.formCard}>
                <h2 style={styles.formTitle}>
                  השאירו פרטים ונחזור אליכם
                </h2>

                <form onSubmit={this.sendEmail} style={styles.form}>

                  <input
                    style={styles.input}
                    type="text"
                    name="name"
                    placeholder="שם מלא"
                    required
                  />

                  <input
                    style={styles.input}
                    type="tel"
                    name="phone"
                    placeholder="טלפון"
                    required
                  />

                  <textarea
                    style={{ ...styles.input, height: "120px" }}
                    name="message"
                    placeholder="איך נוכל לעזור?"
                    required
                  />

                  {/* CAPTCHA בתוך הטופס */}
                  <div style={{ margin: "10px auto" }}>
                    <ReCAPTCHA
                      ref={this.recaptchaRef}
                      sitekey="6LdxKdUdAAAAAGOyVnl1Fs8_GimLD8I8ELh4KDhW"
                      onChange={this.handleCaptchaChange}
                    />
                  </div>

                  <button
                    type="submit"
                    style={styles.submitBtn}
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? (
                      <div style={styles.spinner}></div>
                    ) : (
                      "שליחת הודעה"
                    )}
                  </button>
                </form>
              </div>
            </LightSpeed>
          </div>
        </Container>
      </div>
    );
  }
}
const styles = {
  container: {
    direction: 'rtl',
    padding: '60px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '40px'
  },

  socialWrapper: {
    display: 'flex',
    gap: '20px',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },

  socialIcon: {
    width: '60px',
    height: '60px',
    backgroundColor: '#fff',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
    cursor: 'pointer',
  },

  imgIcon: {
    width: '30px',
    height: '30px',
    objectFit: 'contain'
  },

  formCard: {
    width: '100%',
    maxWidth: '500px',
    backgroundColor: '#fff',
    padding: '40px',
    borderRadius: '20px',
    boxShadow: '0 20px 40px rgba(0,0,0,0.05)',
    textAlign: 'center'
  },

  formTitle: {
    fontSize: '1.5rem',
    color: '#2d3748',
    marginBottom: '30px',
    fontWeight: '700'
  },

  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },

  input: {
    width: '100%',
    padding: '15px 20px',
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    backgroundColor: '#f8fafc',
    fontSize: '1rem',
    textAlign: 'right',
    outline: 'none'
  },

  submitBtn: {
    padding: '15px',
    borderRadius: '12px',
    border: 'none',
    backgroundColor: '#3182ce',
    color: '#fff',
    fontSize: '1.1rem',
    fontWeight: '600',
    cursor: 'pointer',
    transition: '0.3s',
    marginTop: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '50px'
  },

  spinner: {
    width: '22px',
    height: '22px',
    border: '3px solid #fff',
    borderTop: '3px solid rgba(255,255,255,0.3)',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  }
};
////React.render(<Contact/>, document.getElementById('app'));






////<Button   onClick={ () => { this.scrollStep();}}  className="btnbtn" variant="primary"> למעלה</Button>

///<Button  a href = 'mailto:shani.aviv.arch@gmail.com?body="Yourbody"&subject="a subject".com' className="btnbtn" variant="primary">שליחה למייל</Button>


////<Button  a href="https://wa.me/972551234567" className="btnbtn" >  <img className="im"  src={ccc} alt="3"  a href="https://wa.me/972551234567"  />&nbsp;&nbsp;שליחת הודעה</Button>




///<img className="mobile" src={c} alt="3"/> <img className="mobile" src={cc} alt="3"/>


////<Button target="_blank"  className="teee" variant="Light"  a href="tel:052-4816141"><span></span>  חייגו אלינו &nbsp;<img  src={dd} alt="1"/> </Button><br></br>
///<Button target="_blank"    a href="https://wa.me/972524816141"  className="teee" variant="Light"  >שליחת הודעה  &nbsp;<img src={ccc} alt="3"  /> </Button>
////</Fade>
///<Fade left>
///<Button a href={`https://waze.com/ul?ll=${this.state.linkLat},${this.state.linkLng}&navigate=yes`} target="_blank" Open in Waze   className="teee" variant="Light" > נווטו אלינו &nbsp;< img src={c}  alt="1"/>  </Button>
////Button target="_blank" a href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to= shani.aviv.arch@gmail.com" onClick={() => {alert('לחצו אישור לשליחת מייל'); }}  className="teee" variant="Light">שליחה למייל &nbsp; <img src={cc} alt="3"  /></Button>